import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MsOptions } from '../../../services/global/global-interfaces';
import { API, CompanyDTO, CompanyFullDTO, CullCategoryDTO } from '../../../services/api/api';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { UtilService } from '../../../services/util.service';
import { ErrorService } from '../../../services/error.service';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { CompaniesComponent } from '../../company/companies/companies.component';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sb-page-cull-category-edit',
  templateUrl: './cull-category-edit.component.html',
  styleUrls: ['./cull-category-edit.component.scss'],
  standalone: false,
})
export class CullCategoryEditComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  msCategoryOptions: MsOptions;
  @Input() cullCategory: CullCategoryDTO;
  @Input() company: CompanyFullDTO;
  @Output() saveClick: EventEmitter<boolean>;
  filterCategories: CullCategoryDTO[];
  companyDisabled: boolean;

  constructor(
    public api: API,
    public modalNavigationService: ModalNavigationService,
    public util: UtilService,
    public modal: ModalService,
    public translate: TranslateService,
    public errorHandler: ErrorService
  ) {
    this.companyDisabled = false;
    this.filterCategories = [];
    this.saveClick = new EventEmitter();
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.cullCategory = this.modalNavigationService.getCurrentNavigation().data.cullCategory;
      this.company = this.modalNavigationService.getCurrentNavigation().data.company;
    }
    if (this.company) {
      this.companyDisabled = true;
    }
  }

  msRequest(type: string, options?: MsOptions) {
    if (type === 'CULL_CATEGORIES') {
      if (options) {
        this.msCategoryOptions = options;
      }
      if (this.msCategoryOptions?.pagination) {
        this.api
          .ca_md_CullCategory_retrieveAll(
            {
              search: this.util.encodeSearchQueryParam(false, this.msCategoryOptions?.search),
              company: this.company?.id ? [this.company.id] : null,
              notInHierarchyOf: this.cullCategory?.id ?? null,
            },
            this.msCategoryOptions?.pagination
          )
          .subscribe({
            next: (categories: CullCategoryDTO[]) => {
              this.filterCategories = categories;
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
      }
    }
  }

  update($event: any[], type: string) {
    if (type === 'CULL_CATEGORIES') {
      if ($event && $event.length > 0) {
        this.cullCategory.parent = $event[0];
      } else {
        this.cullCategory.parent = null;
      }
    }
  }

  selectCompany() {
    if (!this.isInModalContext) {
      this.modal
        .showNavigationModal({
          entryComponent: { value: CompaniesComponent, data: {} },
          title: null,
          modalOptions: { windowClass: 'bigXL' },
        })
        .then((result: CompanyDTO) => {
          if (result) {
            this.cullCategory.company = result;
          } else {
            this.cullCategory.company = null;
          }
        })
        .catch(() => {});
    }
  }
}
